/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as Filter } from '../../assets/svg/filter.svg';
export default Filter;
